import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BannerTable from "./components/BannerTable";
import BannerModal from "./components/BannerModal";
import StatusConfirmationModal from "./components/StatusConfirmationModal";
import Button from "../../components/ui/Button";
import {
  deleteAdvertismentService,
  getAdvertisementsService,
  updateAdvertisementService,
} from "redux/services/general_service";
import { toast } from "react-toastify";

const BannerManagement = () => {
  const dispatch = useDispatch();
  const { advertisment } = useSelector((state) => state.general);

  const [campaigns, setCampaigns] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingBanner, setEditingBanner] = useState(null);

  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [selectedBanner, setSelectedBanner] = useState(null);
  const [loadingStatus, setLoadingStatus] = useState(false);

  const [loadingOrder, setLoadingOrder] = useState(false);

  /* =============================
     🔹 Get Data
  ============================== */
  useEffect(() => {
    dispatch(getAdvertisementsService({ page: 1, type: "banner" }));
  }, [dispatch]);

  useEffect(() => {
    if (advertisment) {
      setCampaigns(advertisment);
    }
  }, [advertisment]);

  /* =============================
     🔹 Handle Reorder
  ============================== */
 const handleReorder = async ({ movedItem, newOrder }) => {
  try {
    setLoadingOrder(true);

    const formData = new FormData();

    formData.append("order", newOrder);

    await dispatch(
      updateAdvertisementService({
        id: movedItem.id,
        formData,
      })
    );

    toast.success("تم تحديث الترتيب بنجاح");
  } catch (error) {
    toast.error("فشل تحديث الترتيب");
  } finally {
    setLoadingOrder(false);
  }
};

  /* =============================
     🔹 Delete Banner
  ============================== */
  const handleDelete = async (banner) => {
    console.log(banner);
    try {
      await dispatch(deleteAdvertismentService(banner.id));
      toast.success("تم حذف البنر بنجاح");
      dispatch(getAdvertisementsService({ page: 1, type: "banner" }));
    } catch {
      toast.error("فشل حذف البنر");
    }
  };

  /* =============================
     🔹 Toggle Status
  ============================== */
  const handleToggleStatus = (banner, action) => {
    const newStatus = action === "active" ? 1 : 0;
    setSelectedBanner({ ...banner, newStatus });
    setStatusModalOpen(true);
  };

  const handleConfirmStatus = async () => {
    try {
      setLoadingStatus(true);

      const formData = new FormData();

      formData.append("is_active", selectedBanner.newStatus);

      const response = await dispatch(
        updateAdvertisementService({
          id: selectedBanner.id,
          formData,
        }),
      );

      if (response?.payload?.status === 200) {
        toast.success("تم تحديث الحالة بنجاح");
        dispatch(getAdvertisementsService({ page: 1, type: "banner" }));
        setStatusModalOpen(false);
      }
    } catch {
      toast.error("فشل تحديث الحالة");
    } finally {
      setLoadingStatus(false);
    }
  };

  return (
    <div className="p-6">
      <div className="flex justify-between mb-6">
        <h1 className="text-2xl font-bold">إدارة البنرات</h1>

        <Button
          onClick={() => {
            setEditingBanner(null);
            setShowModal(true);
          }}
        >
          إضافة بنر
        </Button>
      </div>

      <BannerTable
        campaigns={campaigns}
        setCampaigns={setCampaigns}
        onReorder={handleReorder}
        onEdit={(banner) => {
          setEditingBanner(banner);
          setShowModal(true);
        }}
        onDelete={handleDelete}
        onToggleStatus={handleToggleStatus}
        loadingOrder={loadingOrder}
      />

      <BannerModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        banner={editingBanner}
      />

      <StatusConfirmationModal
        isOpen={statusModalOpen}
        onClose={() => setStatusModalOpen(false)}
        onConfirm={handleConfirmStatus}
        banner={selectedBanner}
        loading={loadingStatus}
      />
    </div>
  );
};

export default BannerManagement;
